module.exports = __webpack_public_path__ + "static/media/deno.40025ebb.png";